import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

export const StyledImage = styled.img`
  opacity: .5;
`;

const useStyle = makeStyles(() => ({
  uploadImage: {
    paddingBottom: 10,
  },
  dateCustom: {
    width: '270px',
    '& .MuiIconButton-root': {
      color: '#50B940',
    },
  },
  buttonImage: {
    background: 'var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box',
    border: '1px solid #50B940',
    borderRadius: '5px',
    opacity: 1,
    width: '300px',
    height: '33px',
    letterSpacing: '0px',
    color: '#50B940',
    textTransform: 'initial',
  },
  formLabel: {
    color: 'var(--unnamed-color-575756)',
    font: 'normal normal normal 14px/17px Muli',
    letterSpacing: '0px',
    textAlign: 'left',
    opacity: 1,
  },
  mat_icon: {
    height: '15px',
    width: '15px',
  },
  paperbox: {
    height: '40px',
    width: 'fit-content',
  },
  subInfoLabel: {
    fontSize: '0.7rem',
  },
  errorSubText: {
    color: '#d61103',
    margin: '0 0 0 5px',
    fontSize: '0.7rem',
  },
}));

export default useStyle;
